export default {"src":"/_next/static/media/search.c1086a64.svg","height":26,"width":26};